import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import Actions from './Actions';
import TitleText from './TitleText';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  rootHidden: {
    display: 'none',
  },
  actions: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  title: {
    marginLeft: theme.spacing(3),
  },
});

const DialogTitleModernTransparentHeader = ({
  className,
  classes,
  ActionProps,
  TitleTextProps,
}) => {
  return (
    <>
      <DialogTitle
        className={classNames(className, classes.root, {
          [classes.rootHidden]: !TitleTextProps.title,
        })}
        disableTypography
      >
        <TitleText
          className={classes.title}
          {...TitleTextProps}
        />

      </DialogTitle>
      <Actions
        className={classes.actions}
        {...ActionProps}
      />
    </>
  );
};

DialogTitleModernTransparentHeader.propTypes = {
  ActionProps: PropTypes.object.isRequired,
  TitleTextProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(DialogTitleModernTransparentHeader);
